import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackRoomModuleClick } from '../../utils/tracking/searchBrowse/nullResultsTracking';

// components
import { SbRespNullSearchResultsHeader } from './SbRespNullSearchResultsHeader';
import { SbRespNullSearchResultsTilesLoader } from './SbRespNullSearchResultsTilesLoader';
import { CategoryRooms } from 'dibs-buyer-layout/exports/CategoryLinks';
import { SbRespFollowSearchBannerLazy } from '../SbRespFollowSearchBanner/SbRespFollowSearchBannerLazy';
import { SbSharedFollowSearchProvider } from '../SbSharedFollowSearchProvider/SbSharedFollowSearchProvider';

const onRoomModuleClick = (e, { room }) => trackRoomModuleClick(room.type);

export const SbRespNullSearchResultsComponent = props => {
    const { user, page, relay, viewer, searchTerm, itemSearch, uriRef, isClient } = props;
    const { isShopByRoomEnabled } = viewer;
    const { environment } = relay;

    return (
        <SbSharedFollowSearchProvider
            user={user}
            page={page}
            uriRef={uriRef}
            searchTerm={searchTerm}
            itemSearch={itemSearch}
            thinTrackingEnabled={false}
        >
            {({
                showFollowButton,
                isFollowing,
                followSearchValue,
                refetchFollow,
                isCategorySearch,
            }) => (
                <React.Fragment>
                    <SbRespNullSearchResultsHeader
                        itemSearch={itemSearch}
                        searchTerm={searchTerm}
                    />
                    {isClient && (
                        <SbRespFollowSearchBannerLazy
                            user={user}
                            viewer={viewer}
                            buttonSize="large"
                            uriRef={uriRef}
                            isFollowing={isFollowing}
                            refetchFollow={refetchFollow}
                            showFollowButton={showFollowButton}
                            followSearchValue={followSearchValue}
                            isCategorySearch={isCategorySearch}
                        />
                    )}
                    <SbRespNullSearchResultsTilesLoader environment={environment} />
                    {isShopByRoomEnabled && <CategoryRooms onClick={onRoomModuleClick} />}
                </React.Fragment>
            )}
        </SbSharedFollowSearchProvider>
    );
};

SbRespNullSearchResultsComponent.propTypes = {
    user: PropTypes.object,
    uriRef: PropTypes.string,
    viewer: PropTypes.object,
    searchTerm: PropTypes.string,
    page: PropTypes.number.isRequired,
    itemSearch: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    isClient: PropTypes.bool,
};

export const SbRespNullSearchResults = createFragmentContainer(SbRespNullSearchResultsComponent, {
    user: graphql`
        fragment SbRespNullSearchResults_user on User {
            ...SbRespFollowSearchBanner_user
            ...SbSharedFollowSearchProvider_user
        }
    `,
    viewer: graphql`
        fragment SbRespNullSearchResults_viewer on Viewer {
            isShopByRoomEnabled: isEnabledByLocale(featureName: "SHOP_BY_ROOM")
            ...SbRespFollowSearchBanner_viewer
        }
    `,
    itemSearch: graphql`
        fragment SbRespNullSearchResults_itemSearch on ItemSearchQueryConnection {
            ...SbSharedFollowSearchProvider_itemSearch
            ...SbRespNullSearchResultsHeader_itemSearch
        }
    `,
});
